import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Video18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M5.5 12C5.5 12.5523 5.05228 13 4.5 13C3.94772 13 3.5 12.5523 3.5 12C3.5 11.4477 3.94772 11 4.5 11C5.05228 11 5.5 11.4477 5.5 12Z'
      fill='currentColor'
    />
    <path
      d='M7.5 13C8.05228 13 8.5 12.5523 8.5 12C8.5 11.4477 8.05228 11 7.5 11C6.94772 11 6.5 11.4477 6.5 12C6.5 12.5523 6.94772 13 7.5 13Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.43478 2.25C0.738878 2.25 0.25 2.83525 0.25 3.46154V14.5385C0.25 15.1647 0.738878 15.75 1.43478 15.75H10.5652C11.2611 15.75 11.75 15.1647 11.75 14.5385V12.4606L16.1968 13.5723C16.9858 13.7695 17.75 13.1728 17.75 12.3596V5.64039C17.75 4.82717 16.9858 4.23047 16.1968 4.42771L11.75 5.53942V3.46154C11.75 2.83525 11.2611 2.25 10.5652 2.25H1.43478ZM1.75 14.25V3.75H10.25V14.25H1.75ZM11.75 7.08558V10.9144L16.25 12.0394V5.96058L11.75 7.08558Z'
      fill='currentColor'
    />
  </Svg>
);

Video18.displayName = 'Video18';
export default Video18;
